<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 *  dashboard component
 */
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ModelListSelect,
  },
  data() {
    return {
      load_status: true,
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Main Dashboard",
          active: true,
        },
      ],

      timeFilters: [
        { title: "Today", value: "today" },
        { title: "Yesterday", value: "yesterday" },
        { title: "Last 7 days", value: "last7" },
        { title: "Last 14 days", value: "last14" },
        { title: "Last 28 days", value: "last28" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
        { title: "Customise", value: "custom" },
      ],
      filterData: {
        time: "today",
        dateRange: "",
      },
      dashboardLabel: "today",

      // GRAPH DARA

      // INCOME AND EXPENSES GRAPH
      chartData: {
        series: [
          {
            name: "Income",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Expense",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: false,
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      selection: "all",

      // SERVICE ANALYSIS GRAPH
      columnChart: {
        series: [
          {
            name: "Requested ",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "45%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#556ee6"],
          xaxis: {
            categories: [
              "...",
              "...",
              "...",
              "...",
              "...",
              "...",
              "...",
              "...",
              "...",
              "...",
            ],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " times";
              },
            },
          },
        },
      },
    };
  },
  watch: {
    graphsData(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.SetGraph();
        }, 3000);
      }
    },
  },
  methods: {
    ...mapActions({
      dashboardFetch: "dashboard/fetchDashboard",
      dashboardFilter: "dashboard/filterDashboard",
      FetchGraph: "dashboard/fetchGraph",
      FetchActivePatients: "patients/fetchActivePatients",
      FetchPatients: "patients/fetchPatients",
      FetchConsultationPatients: "doctor/fetchConsultationPatients",
      FetchAntenatalPatients: "doctor/fetchAntenatalPatients",
      FetchDentalPatients: "doctor/fetchDentalPatients",
      FetchRadiologyPatients: "doctor/fetchRadiologyPatients",
      FetchProcedurePatients: "doctor/fetchProcedurePatients",
      FetchPatientPayments: "payments/fetchPatientPayments",
    }),

    update_load() {
      this.load_status = false;
      this.$store.commit("dashboard/SET_LOADED");
    },
    setLabel() {
      if (this.filterData.time == "today") {
        this.dashboardLabel = "today";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "yesterday") {
        this.dashboardLabel = "yesterday";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last7") {
        this.dashboardLabel = "in last 7 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last14") {
        this.dashboardLabel = "in last 14 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last28") {
        this.dashboardLabel = "in last 28 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "month") {
        this.dashboardLabel = "in this month";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "quarter") {
        this.dashboardLabel = "in this quarter";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.dashboardLabel = "";
      }
    },

    FilterDash() {
      if (this.filterData.time == "custom" && this.filterData.dateRange == "") {
        return;
      }
      if (
        this.filterData.time == "custom" &&
        this.filterData.dateRange[0] == null &&
        this.filterData.dateRange[1] == null
      ) {
        return;
      }
      this.dashboardFilter(this.filterData);
    },

    SetGraph() {
      // LINE GRAPH
      this.columnChart.chartOptions.xaxis.categories[0] =
        this.graphData.labels[0];
      this.columnChart.chartOptions.xaxis.categories[1] =
        this.graphData.labels[1];
      this.columnChart.chartOptions.xaxis.categories[2] =
        this.graphData.labels[2];
      this.columnChart.chartOptions.xaxis.categories[3] =
        this.graphData.labels[3];
      this.columnChart.chartOptions.xaxis.categories[4] =
        this.graphData.labels[4];
      this.columnChart.chartOptions.xaxis.categories[5] =
        this.graphData.labels[5];
      this.columnChart.chartOptions.xaxis.categories[6] =
        this.graphData.labels[6];
      this.columnChart.chartOptions.xaxis.categories[7] =
        this.graphData.labels[7];
      this.columnChart.chartOptions.xaxis.categories[8] =
        this.graphData.labels[8];
      this.columnChart.chartOptions.xaxis.categories[9] =
        this.graphData.labels[9];
      this.chartData.series[0].data = this.graphData.collected;
      this.chartData.series[1].data = this.graphData.spent;
      this.columnChart.series[0].data = this.graphData.counts;

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
  },
  computed: {
    ...mapState("dashboard", ["graphsData"]),
    ...mapGetters("auth", [
      "clinic_name",
      "branch_name",
      "user_permissions",
      "license",
    ]),
    ...mapGetters("audits", ["all_notifications"]),
    ...mapGetters("dashboard", [
      "dashboardData",
      "loadedStatus",
      "filterStatus",
      "graphData",
    ]),
  },

  created() {
    this.dashboardFetch();
    // this.FetchActivePatients();
    // this.FetchPatients();
    this.FetchGraph();
    this.SetGraph();
  },
};
</script>
<style scoped>
.spinner-grow {
  width: 1000px;
  height: 0;
}
</style>

<template>
  <Layout>
    <PageHeader
      :title="
        clinic_name ? clinic_name : '--- ' + branch_name ? branch_name : '---'
      "
      :items="items"
    />

    <div>
        <div v-if="dashboardData.labmsg">
            <b-alert show dismissible>
                <h3>{{ dashboardData.labmsg }} <b>&rArr;</b></h3>
            </b-alert>
        </div>
      <div
        class="card"
        v-if="user_permissions.dashboard_filters == 1 ? true : false"
      >
        <div class="card-body">
          <div class="row justify-content-end">
            <div class="col-md-2">
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="filterData.time"
                option-value="value"
                size="sm"
                @input="
                  setLabel();
                  FilterDash();
                "
                option-text="title"
                placeholder="Select Performance"
              >
              </model-list-select>
            </div>
            <div class="col-md-2" v-show="filterData.time == 'custom'">
              <date-picker
                v-model="filterData.dateRange"
                range
                append-to-body
                @change="FilterDash"
                lang="en"
                confirm
              ></date-picker>
            </div>
            <div class="col-md-2 d-grid gap-2">
              <button class="btn btn-primary" type="button" @click="FilterDash">
                <span class="fas fa-filter"></span> Filter
                <b-spinner
                  v-show="filterStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="dashboardData.license.expired || dashboardData.license.warningmsg">
        <b-alert show variant="warning" v-if="!dashboardData.license.expired && dashboardData.license.warningmsg">
          <h4 class="alert-heading">License about to expire</h4>
          <p>
           {{dashboardData.license.warningmsg}}
          </p>
          
        </b-alert>
        <span v-else-if="!dashboardData.license.expired  && !dashboardData.license.msg">
        </span>
           <b-alert show variant="danger" v-else>
          <h4 class="alert-heading">!!!!! License Expired !!!!!!</h4>
          <p>
            Your facility account license expired contact Nugsoft Technologies
            to renew your license
          </p>
       
        
        </b-alert>
      </div>
      <div
        class="row"
        v-if="user_permissions.dashboard_summary == 1 ? true : false"
      >
        <div class="col-lg-3">

        </div>
        <div class="col-lg-3">

        </div>
        <div class="col-lg-3">

        </div>
        <div class="col-lg-3">

        </div>
      </div>
        <div class="row" v-if="user_permissions.dashboard_summary == 1 ? true : false">
            <div class="col-sm-7">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="card mini-stats-wid border border-primary">
                            <router-link to="/patients/active">
                                <div class="card-body">
                                    <div class="d-flex flex-wrap">
                                        <div class="me-3">
                                            <p class="text-muted mb-2">Visits {{ dashboardLabel }}</p>
                                            <h5 class="mb-0">{{ dashboardData.visits }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="card mini-stats-wid border border-primary">
                            <router-link to="/reports/income_report">
                                <div class="card-body">
                                    <div class="d-flex flex-wrap">
                                        <div class="me-3">
                                            <p class="text-muted mb-2">Collected {{ dashboardLabel }}</p>
                                            <h5 class="mb-0">{{ dashboardData.sales }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="card blog-stats-wid border border-primary">
                            <router-link to="/expense/report">
                                <div class="card-body">
                                    <div class="d-flex flex-wrap">
                                        <div class="me-3">
                                            <p class="text-muted mb-2">Spent {{ dashboardLabel }}</p>
                                            <h5 class="mb-0">{{ dashboardData.expenses }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-5">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="card blog-stats-wid border border-primary">
                            <router-link to="/reports/pharmacy_stock_value">
                                <div class="card-body">
                                    <div class="d-flex flex-wrap">
                                        <div class="me-3">
                                            <p class="text-muted mb-2">Stock Value (Buying price)</p>
                                            <h5 class="mb-0">{{ dashboardData.buying_stock_value }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card blog-stats-wid border border-primary">
                            <router-link to="/reports/pharmacy_stock_value">
                                <div class="card-body">
                                    <div class="d-flex flex-wrap">
                                        <div class="me-3">
                                            <p class="text-muted mb-2">Stock Value (Selling price)</p>
                                            <h5 class="mb-0">{{ dashboardData.selling_stock_value }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <!-- end row -->

      <div class="row">
        <template>
          <div
            class="col-md-6"
            v-if="user_permissions.expense_graph == 1 ? true : false"
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Income Vs Expenses this year</h4>
                <!-- Line with Data Labels chart -->
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="chartData.series"
                  :options="chartData.chartoptions"
                ></apexchart>
              </div>
            </div>
          </div>
        </template>
        <div class="col-md-6" v-if="user_permissions.sales_graph == 1 ? true : false">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Services demand this year</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="columnChart.series"
                :options="columnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
